import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _Avatar from 'reakit/Avatar';

var circleProperties = css(["&{border-radius:50%;}"]);
var fitProperties = function fitProperties(props) {
  if (!props.fit) return null;

  if (props.fit === 'contain') {
    return css(["object-fit:contain;", ";", ";", ";"], function (props) {
      return props.fitPosition ? css(["object-position:", ";"], props.fitPosition) : '';
    }, theme('fannypack.Avatar.fit.base'), theme('fannypack.Avatar.fit.contain'));
  }

  if (props.fit === 'cover') {
    return css(["object-fit:cover;", ";", ";", ";"], function (props) {
      return props.fitPosition ? css(["object-position:", ";"], props.fitPosition) : '';
    }, theme('fannypack.Avatar.fit.base'), theme('fannypack.Avatar.fit.cover'));
  }

  return null;
};
var sizeProperties = {
  xsmall: css(["&{font-size:8px;width:20px;height:20px;}&{", ";}"], theme('fannypack.Avatar.sizes.xsmall')),
  small: css(["&{font-size:16px;width:40px;height:40px;}&{", ";}"], theme('fannypack.Avatar.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Avatar.sizes.default')),
  medium: css(["&{font-size:32px;width:80px;height:80px;}&{", ";}"], theme('fannypack.Avatar.sizes.medium')),
  large: css(["&{font-size:48px;width:100px;height:100px;}&{", ";}"], theme('fannypack.Avatar.sizes.large'))
};
var AvatarCircle = styled(Box).withConfig({
  displayName: "styled__AvatarCircle",
  componentId: "k1acy4-0"
})(["align-items:center;background-color:", ";color:", ";display:flex;justify-content:center;font-size:24px;height:", ";width:", ";", ";", ";", ";"], function (props) {
  return palette(props.palette || '')(props);
}, function (props) {
  return props.color ? props.color : palette(props.palette + "Inverted")(props);
}, function (props) {
  return typeof props.styledSize === 'number' ? props.styledSize + "px" : '60px';
}, function (props) {
  return typeof props.styledSize === 'number' ? props.styledSize + "px" : '60px';
}, function (props) {
  return props.kind === 'circle' && circleProperties;
}, function (props) {
  return typeof props.styledSize === 'string' ? sizeProperties[props.styledSize] : null;
}, theme('fannypack.Avatar.Circle.base'));
var AvatarImage = styled(_Avatar).withConfig({
  displayName: "styled__AvatarImage",
  componentId: "k1acy4-1"
})(["font-size:24px;height:", ";width:", ";", ";", ";&{", ";}", ";"], function (props) {
  return typeof props.styledSize === 'number' ? props.styledSize + "px" : '60px';
}, function (props) {
  return typeof props.styledSize === 'number' ? props.styledSize + "px" : '60px';
}, function (props) {
  return props.kind === 'circle' && circleProperties;
}, function (props) {
  return typeof props.styledSize === 'string' ? sizeProperties[props.styledSize] : null;
}, fitProperties, theme('fannypack.Avatar.Image.base'));

export default AvatarImage;
export { AvatarCircle, circleProperties, fitProperties, sizeProperties };
